var map = {
	"./en.yml": 42793,
	"./en_old.yml": 10158,
	"./et.yml": 17276,
	"./et_old.yml": 48791,
	"./ru.yml": 13552,
	"./ru_old.yml": 87161
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 73292;
module.exports = webpackAsyncContext;